import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Define the structure for departments, including 'id' for content mapping
// and 'name' for display in the sidebar.
const departments = [
    { "name": "Introduction", "id": "about" },
    { "name": "Offered Courses", "id": "courses" },
    { "name": "Faculty Members", "id": "faculty" },
    { "name": "Timetable", "id": "timetable" },
    { "name": "Facilities", "id": "facilities" },
    { "name": "Seminars/Conferences/Workshops", "id": "events" },
    { "name": "Research Scholars", "id": "researchScholars" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

// Content for each section, mapped by their 'id'
const departmentContent = {
    "about": (
        <div>
            <p className="mb-2">The vision for the Philosophy Department at Maharshi Valmiki Sanskrit University originated from a profound quest to ignite deep understanding and expertise in Indian Philosophy, as expounded by ancient sages and enshrined in sacred scriptures. The Department of Philosophy at Maharshi Valmiki Sanskrit University presents a profound and distinctive understanding of India's rich philosophical heritage, fostering deep comprehension across various disciplines within major philosophical schools. This unique approach enables scholars to master the complexities of Indian Philosophy and make meaningful contributions to its ongoing evolution.</p>
            <p className="mb-2">The Philosophy Department focuses on teaching all philosophical systems. It develops comparative study of all philosophical systems. It provides a comprehensive understanding of India's rich philosophical heritage and promotes unique insight, intellectual development, and spiritual exploration.</p>
        </div>
    ),
    "courses": (
        <div>
            <p>The Department of Philosophy offers Shastri and Acharya courses.</p>
        </div>
    ),
    "faculty": (
        <div className="mb-4">

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Photo</th>
                            <th>Professor's Name</th>
                            <th>Designation</th>
                            <th>Highest Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. विनय गोपाल त्रिपाठी (दर्शन विभाग).JPG")}
                                    alt="Dr. Vinay Gopal Tripathi"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Vinay Gopal Tripathi</td>
                            <td>In-charge, Assistant Professor</td>
                            <td>Ph.D., M.Phil., UGC-NET</td>
                            <td>8076723202</td>
                            <td>
                                <a href="mailto:hoddarshan@mvsu.ac.in">
                                    hoddarshan@mvsu.ac.in
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    "timetable": (
        <div>
            <p>Timetable is not available.</p>
        </div>
    ),
    "facilities": (
        <div>
            <p>Details of facilities are not available.</p>
        </div>
    ),
    "events": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">The Department of Philosophy organized a seven-day workshop on Vyakarana Mahabhashya from 08/08/2023 to 15/08/2023 in 2023. Through this workshop, university students understood the philosophical aspects of Vyakarana Shastra.</li>
                <li className="list-group-item bg-transparent border-0">The Department of Philosophy, in collaboration with Maharshi Valmiki Research Peeth, also organized a two-day international seminar on October 26 and 27, 2023. Internationally renowned scholars participated in this seminar. Through this seminar, an MoU was signed with Nepal Sanskrit University, which will enable the university to use manuscripts and other resources for research work.</li>
            </ul>
        </div>
    ),
    "researchScholars": (
        <div>
            <p>Currently, no research scholars are registered.</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">Philosophy department students achieved success in NET and JRF examinations.</li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <p>Contact details are not available.</p>
        </div>
    )
};

export default function FacultyPhilosophy_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content to "about" (Introduction)

    // Helper to find the display name of the active section
    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "Department Section"; // Default if ID not found
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        // Hide sidebar on click for small screens
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle Menu"
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">Philosophy Faculty</h5>
                <nav className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "bg-primary text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>

            {/* Main Content Area */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {/* Dynamic Header for the current section */}
                <h4 className="mb-3 text-primary text-center">{getActiveSectionName()}</h4>
                {/* Render content based on activeContentId */}
                {departmentContent[activeContentId] || <p className="text-muted">Please select a section.</p>}
            </main>

            {/* Inline CSS for transition effect and hover effect */}
            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* Lighter gray on hover for inactive items */
                    color: #000 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}